import { render, staticRenderFns } from "./CourseDashboard.vue?vue&type=template&id=6face175&scoped=true&"
import script from "./CourseDashboard.vue?vue&type=script&lang=js&"
export * from "./CourseDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CourseDashboard.vue?vue&type=style&index=0&id=6face175&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6face175",
  null
  
)

export default component.exports